import React from "react";
import { AUTH_PREFIX_PATH, APP_PREFIX_PATH } from "configs/AppConfig";

export const publicRoutes = [
  {
    key: "login",
    path: `${AUTH_PREFIX_PATH}/login`,
    component: React.lazy(() =>
      import("pages/login/authentication/login")
    ),
  },
  {
    key: "login-1",
    path: `${AUTH_PREFIX_PATH}/login-1`,
    component: React.lazy(() =>
      import("pages/login/authentication/login-1")
    ),
  },
  {
    key: "error-page-1",
    path: `${AUTH_PREFIX_PATH}/error-page-1`,
    component: React.lazy(() => import("pages/login/errors/error-page-1")),
  },
  {
    key: "error-page-2",
    path: `${AUTH_PREFIX_PATH}/error-page-2`,
    component: React.lazy(() => import("pages/login/errors/error-page-2")),
  },
  {
    key: "apply-form",
    path: `${AUTH_PREFIX_PATH}/apply-form`,
    component: React.lazy(() =>
      import("pages/login/components/apply-form")
    ),
  },
];

export const protectedRoutes = [
  {
    key: "parent.dashboard",
    path: `${APP_PREFIX_PATH}/parent/dashboard`,
    component: React.lazy(() => import("pages/dashboards/parent/index")),
  },
  {
    key: "parent.my-children",
    path: `${APP_PREFIX_PATH}/parent/my-children`,
    component: React.lazy(() => import("pages/my-children/index")),
  },
  {
    key: "parent.payments",
    path: `${APP_PREFIX_PATH}/parent/fees-payments`,
    component: React.lazy(() => import("pages/fee-and-payments/index")),
  },
  {
    key: "parent.calender",
    path: `${APP_PREFIX_PATH}/parent/calender`,
    component: React.lazy(() => import("pages/calender/index")),
  },

  {
    key: "parent.academics.attendance",
    path: `${APP_PREFIX_PATH}/parent/academics/attendance`,
    component: React.lazy(() => import("pages/academics/attendence/index")),
  },
  {
    key: "parent.academics.exam",
    path: `${APP_PREFIX_PATH}/parent/academics/exam`,
    component: React.lazy(() => import("pages/academics/exam/index")),
  },
  {
    key: "parent.academics.funds",
    path: `${APP_PREFIX_PATH}/parent/academics/funds`,
    component: React.lazy(() => import("pages/academics/funds/index"))
  },
  {
    key: "parent.academics.attendance",
    path: `${APP_PREFIX_PATH}/parent/academics/result`,
    component: React.lazy(() => import("pages/academics/result/index")),
  },
  {
    key: "parent.academics.ptm",
    path: `${APP_PREFIX_PATH}/parent/academics/ptm`,
    component: React.lazy(() => import("pages/academics/ptm/index"))
  },
  
  
  {
    key: "parent.tracking",
    path: `${APP_PREFIX_PATH}/parent/tracking`,
    component: React.lazy(() => import("pages/tracking/index")),
  },
  {
    key: "parent.messages",
    path: `${APP_PREFIX_PATH}/parent/messages`,
    component: React.lazy(() => import("pages/messages/index")),
  },
  {
    key: "parent.contribution",
    path: `${APP_PREFIX_PATH}/parent/contribution`,
    component: React.lazy(() => import("pages/contribution/index")),
  },
  {
    key: "parent.driver",
    path: `${APP_PREFIX_PATH}/parent/driver`,
    component: React.lazy(() => import("pages/tracking/driverPage")),
  },


 
];
